/** Property ID for 390 Johnson Street (The Hive) in Buildium / Genie. */
export const JOHNSON_390_PROPERTY_ID = '255851';
